import type { ComponentProps, JSX } from 'react';

import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { User } from 'src/app/pages/movement/shared/types';

export type UserCardProps = {
	user: User;
};

export function UserCard({ user, ...rest }: UserCardProps & ComponentProps<typeof Flex>): JSX.Element {
	const { displayName, city, stateCode, country, photo } = user;

	const photoUrl = photo?.userSmall.processing ? undefined : photo?.userSmall.url;

	return (
		<Flex mt={8} sx={{ alignItems: 'center' }} {...rest}>
			<Avatar src={photoUrl} alt="" mr={8} data-testid="user-avatar" />
			<Flex sx={{ flexDirection: 'column', flex: 1 }}>
				<Text size="caption" fontWeight="bold" ellipsis>
					{displayName}
				</Text>
				<Text size="caption" ellipsis>
					{[city, stateCode, country?.countryCode].filter(Boolean).join(', ')}
				</Text>
			</Flex>
		</Flex>
	);
}
